import React from 'react';
import { useNavigate } from 'react-router-dom';

const ThankYouPage = () => {
  const navigate = useNavigate();

  const handleModifyAddress = () => {
    const params = new URLSearchParams(window.location.search);
    navigate(`/confirm-address?${params.toString()}`);
  };

  const handleTrackPackage = () => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('id');
    const access = params.get('access');
    navigate(`/tracking?tracking-id=${access}&submit=1`);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Thank You Message */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Merci pour votre confirmation !
        </h1>
        
        <p className="text-gray-600 mb-6 leading-relaxed">
          Nous vous remercions pour la confirmation de votre adresse. 
          Notre équipe vous contactera prochainement pour la livraison.
        </p>

        {/* Additional Info */}
        {/* <div className="bg-blue-50 rounded-lg p-4 mb-8">
          <div className="flex items-start">
            <svg className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div className="text-left">
              <p className="text-blue-800 font-medium text-sm mb-1">
                Prochaines étapes
              </p>
              <p className="text-blue-700 text-xs leading-relaxed">
                Vous recevrez un SMS/email avec les détails de livraison et un numéro de suivi dans les prochaines heures.
              </p>
            </div>
          </div>
        </div> */}

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleTrackPackage}
            className="w-full py-3 px-4 text-white font-medium rounded-lg transition-all duration-200 hover:shadow-lg hover:scale-105 active:scale-95"
            style={{ backgroundColor: '#f89133' }}
          >
            <div className="flex items-center justify-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Suivre mon colis
            </div>
          </button>
          
          <button
            onClick={handleModifyAddress}
            className="w-full py-3 px-4 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-200"
          >
            <div className="flex items-center justify-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Modifier l'adresse
            </div>
          </button>
        </div>

        {/* Footer Note */}
        <p className="text-gray-400 text-xs mt-6">
          Besoin d'aide ? Contactez notre service client
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;
